<template>
  <div
    class="content-partner-show-view"
  >
    <page-header :breadcrumbs="breadcrumbs" />
    <div
      v-if="contentPartner"
      class="content-partner"
    >
      <div class="partner-heading">
        <div
          v-if="featuredImage"
          class="partner-image-container"
          role="img"
          :style="{ backgroundImage: `url(${featuredImage.url})` }"
        />
        <h2 class="partner-name">
          {{ contentPartner.name }}
        </h2>
        <follow-button
          class="partner-follow"
          :content-partner-id="contentPartner.id"
        />
      </div>
      <div v-html="contentPartner.descriptionHtml" />
      <div
        v-for="type in partnerAssetTypes"
        :key="type"
        class="asset-type-carousel"
      >
        <div class="carousel-header">
          <p class="asset-type-name">
            {{ type }}
          </p>
        </div>
        <carousel
          :item-width="263"
          :tile-count="partnerAssets[type].length"
          tile-type="block"
        >
          <asset-block-tile
            v-for="asset in partnerAssets[type]"
            :key="`${type}-${asset.id}`"
            :asset="asset"
            @tile-clicked="handleTileClick(asset)"
          />
        </carousel>
      </div>
    </div>
  </div>
</template>

<script>
import AssetBlockTile from '@components/singletons/asset-block-tile';
import Carousel from '@components/carousels/carousel';
import FollowButton from '@components/singletons/follow-button';
import PageHeader from '@components/singletons/pageHeader';

import Attachment from '@/classes/attachment';

export default {
  name: 'ContentPartnerShow',
  components: { AssetBlockTile, Carousel, FollowButton, PageHeader },
  data() {
    return {
      assets: {},
    };
  },
  computed: {
    partnerAssetTypes() {
      return ['attachments', 'topics', 'decks', 'learningModules'].filter(type => this.partnerAssets[type]?.length > 0);
    },
    featuredImage() {
      if (this.contentPartner?.featuredImageId) {
        return this.$store.getters['attachments/get'][this.contentPartner.featuredImageId];
      }
    },
    partnerAssets() {
      return {
        attachments: this.assets.attachments?.map(attachmentId => this.$store.getters['attachments/get'][attachmentId]).filter(a => a) || [],
        topics: this.assets.topics?.map(topic => this.$store.getters['topics/topics'][topic.id]).filter(t => t) || [],
        decks: this.assets.decks?.map(deckId => this.$store.getters['decks/get'][deckId]).filter(d => d) || [],
        learningModules: this.assets.learningModules?.map(lm => this.$store.getters['learningModule/get'][lm.id]).filter(lm => lm) || [],
      };
    },
    breadcrumbs() {
      return [{ name: 'Content Partners', route: { name: 'content-partners#index' } }, { name: this.contentPartner.name }];
    },
    contentPartner() {
      return this.$store.getters['contentPartners/get'][this.contentPartnerId];
    },
    contentPartnerId() {
      return this.$route.params.contentPartnerId;
    },
  },
  mounted() {
    this.$store.dispatch('contentPartners/fetchContentPartnerAssets', { id: this.contentPartnerId }).then(data => {
      this.assets = data[this.contentPartnerId];
    });
  },
  methods: {
    handleTileClick(asset) {
      let assetType;
      if (asset instanceof Attachment) {
        assetType = 'attachment';
      } else {
        assetType = 'topic';
      }
      this.$router.push({
        name: 'library#show',
        params: {
          assetId: asset.id,
          assetType,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
  .content-partner-show-view {
    .content-partner {
      max-width: rem-calc(768);
      margin: 0 auto;

      .partner-heading {
        display: flex;
        align-items: center;
        margin-bottom: rem-calc(64);

        .partner-image-container {
          align-items: center;
          border: 1px solid #dedede;
          border-radius: 100%;
          background-position: center;
          background-size: cover;
          display: flex;
          justify-content: center;
          height: rem-calc(128);
          width: rem-calc(128);
        }

        .partner-name {
          @include charter-font;
          margin-left: rem-calc(24);
        }

        .partner-follow {
          margin-left: auto;
        }
      }

      .asset-type-carousel {
        margin-top: rem-calc(24);

        .carousel-header {
          color: #767676;
          display: flex;
          font-size: rem-calc(14);
          font-weight: $semi-bold;
          justify-content: space-between;
          text-transform: uppercase;

          .asset-type-name {
            margin: 0;
          }
        }
      }
    }
  }
</style>
